import { render, staticRenderFns } from "./InformationPersoComponent.vue?vue&type=template&id=5f4ab1ad&scoped=true"
import script from "./InformationPersoComponent.vue?vue&type=script&lang=js"
export * from "./InformationPersoComponent.vue?vue&type=script&lang=js"
import style0 from "./InformationPersoComponent.vue?vue&type=style&index=0&id=5f4ab1ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ab1ad",
  null
  
)

export default component.exports